<script lang="ts">
	import { Alert } from '@Shelly/shelly-design-system';

	export let onError: ((error: unknown) => void) | null = null;
	export let message = '';

	function handleError(error: unknown) {
		if (typeof onError === 'function') onError(error);
	}
</script>

<svelte:boundary onerror={handleError}>
	<slot />

	{#snippet failed()}
		{#if message}
			<Alert type="danger" heading="Error" {message} />
		{/if}
	{/snippet}
</svelte:boundary>
